module.exports = __webpack_public_path__ + "static/media/QRCode.8d6c89db.png";